import { render, staticRenderFns } from "./CreatePrecioModal.vue?vue&type=template&id=89830efc"
import script from "./CreatePrecioModal.vue?vue&type=script&lang=js"
export * from "./CreatePrecioModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports